import React, { useEffect, useState } from "react";
import { FaSignInAlt } from "react-icons/fa";
import { motion } from "framer-motion";
import { NavLink } from 'react-router-dom';
import { Link } from 'react-router-dom';


export default function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
  
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (

      <motion.header
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          className={`sticky top-0 z-50 transition-all duration-300 shadow-md ${
            isScrolled ? 'bg-[#066a75] py-0 shadow-lg' : 'bg-white py-1'
          }`}
        >
        <div className="container mx-auto px-4 py-0 flex justify-between items-center relative overflow-visible">
          {/* LOGO */}
          <div className="relative z-10">
            <Link to="/">
              <img
                src="/logo.png"
                alt="iDisKover Logo"
                className="h-20 md:h-24 w-auto -mb-10 drop-shadow-xl rounded-xl transition hover:scale-105"
              />
            </Link>
          </div>
        <button
            onClick={() => setMenuOpen(!menuOpen)}
            className="sm:hidden text-2xl text-[#ff7a00] focus:outline-none z-50"
          >
            ☰
          </button>
          {/* NAVIGATION */}
          <nav
              className={`${
                isScrolled ? 'text-white' : 'text-gray-700'
              } font-medium absolute sm:static top-full left-0 w-full sm:w-auto sm:flex sm:items-center sm:space-x-6 ${isScrolled ? 'bg-[#066a75]' : 'bg-white'} sm:bg-transparent shadow-md sm:shadow-none z-40 transition-all duration-300 ${
                menuOpen ? 'flex flex-col items-start p-4 space-y-4' : 'hidden sm:flex'
              }`}
            >
            <NavLink to="/" className={({ isActive }) => isActive ? 'font-bold text-[#ff7a00]' : ''}>Home</NavLink>
            <NavLink to="/features" className={({ isActive }) => isActive ? 'font-bold text-[#ff7a00]' : ''}>Features</NavLink>
            <NavLink to="/about" className={({ isActive }) => isActive ? 'font-bold text-[#ff7a00]' : ''}>About Us</NavLink>
            <NavLink to="/contact" className={({ isActive }) => isActive ? 'font-bold text-[#ff7a00]' : ''}>Contact Us</NavLink>
            <NavLink to="/login" className={({ isActive }) => `inline-flex items-center ${isActive ? 'font-bold text-[#ff7a00]' : ''}`}>
              <FaSignInAlt className="mr-1" /> Login
            </NavLink>
          </nav>
        </div>
      </motion.header>

  );
}
